<template>
  <v-list v-if="transportadoras && transportadoras.length">
    <template v-for="(transportadora, index) in transportadoras">
      <v-list-item :key="transportadora.id">
        <v-list-item-content>
          <v-list-item-title>
            <px-indicador-resposta
              :situacao="transportadora.situacaoSolicitacaoResposta"
              tooltip-message-nao-respondeu="Esta transportadora ainda não respondeu"
              tooltip-message-respondeu="Esta transportadora já respondeu"/>
            {{ transportadora.pessoa.nome }}
            <px-popover-transportador :transportador="transportadora"/>
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ transportadora.pessoa.cnpj | cnpj }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider :key="`div-${transportadora.id}`"
                 v-if="index !== (cotacao.transportadoras.length - 1)"/>
    </template>
  </v-list>
</template>

<script>
import { find, get, orderBy } from 'lodash';

export default {
  props: {
    solicitacoes: Array,
    cotacao: Object,
  },
  computed: {
    transportadoras() {
      let { transportadoras } = this.cotacao;
      if (this.solicitacoes && this.solicitacoes.length) {
        transportadoras = this.cotacao.transportadoras.map(transportadora => ({
          ...transportadora,
          situacaoSolicitacaoResposta: get(find(this.solicitacoes, { transportadora: { id: transportadora.id } }), 'situacao'),
        }));
      }
      return orderBy(transportadoras, ['pessoa.nome'], ['asc']);
    },
  },
};
</script>
